import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';


const CouponForm = ({
  feeType,
  setFeeType,
  discountPct,
  setDiscountPct,
  count,
  setCount,
  generateCoupons,
  feeTypeOptions
}) => {
  return (
    <div className="mb-4 flex-shrink-0">
      <div className="bg-white/80 backdrop-blur-xl rounded-xl shadow-lg border border-white/20 p-4 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-indigo-500/10 rounded-full -translate-y-16 translate-x-16"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-purple-400/10 to-pink-400/10 rounded-full translate-y-12 -translate-x-12"></div>

        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg shadow-lg">
              <i className="pi pi-ticket text-white text-sm"></i>
            </div>
            <div>
              <h3 className="text-base font-bold text-gray-900">Generate Coupon Codes</h3>
              <p className="text-xs text-gray-600 mt-0.5">Create and manage discount coupons</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-tag mr-1 text-purple-500 text-xs"></i>Fee Type</label>
            <Dropdown value={feeType} options={feeTypeOptions} onChange={(e) => setFeeType(e.value)} placeholder="Select Fee Type" className="w-full text-sm border border-gray-200 rounded-lg" />
          </div>

          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-percentage mr-1 text-green-500 text-xs"></i>Discount % </label>
            <InputText type="number" placeholder="Enter discount" value={discountPct} onChange={(e) => setDiscountPct(e.target.value)} className="w-full pl-3 pr-3 py-2 text-sm border border-gray-200 rounded-lg" />
          </div>

          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-700 flex items-center"><i className="pi pi-list mr-1 text-orange-500 text-xs"></i>No. of Coupons</label>
            <InputText type="number" placeholder="How many to generate?" value={count} onChange={(e) => setCount(e.target.value)} className="w-full pl-3 pr-3 py-2 text-sm border border-gray-200 rounded-lg" />
          </div>
        </div>
        <Button onClick={generateCoupons}  className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-4 py-2.5 rounded-lg hover:from-purple-700 hover:to-blue-700 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl text-sm">
            <i className="pi pi-plus mr-2 text-sm"></i> Generate Coupons
          </Button>
     
         </div>
          
    </div>
  );
};

export default CouponForm;
